import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
	faBell,
	faEgg,
	faEnvelope, faHatWizard,
	faList, faPhone,
	faPhoneArrowUpRight, faPhonePlus,
	faTasks
} from "@fortawesome/pro-solid-svg-icons";

const typeColor = {
	EMAILING: {
		INCOMING: {
			color: "#EDCD3B",
			icon: faEnvelope,
			textColor: "#FFFFFF"
		}
	},
	OUTGOING: {
		color: "#EDCD3B",
		icon: faEnvelope,
		textColor: "#FFFFFF"
	},
	TASK: {
		notSet: {
			notSet: {
				color: "#481899",
				icon: faTasks,
				textColor: "#FFFFFF"
			}
		},
		YOUTELLO: {
			notSet: {
				icon: faTasks
			},
			INCOMING: {
				color: "#481899",
				icon: faBell,
				textColor: "#FFFFFF"
			},
			TASK: {
				color: "#481899",
				icon: faBell,
				textColor: "#FFFFFF"
			},
			CALLBACK: {
				color: "#481899",
				icon: faPhonePlus,
				textColor: "#FFFFFF"
			}
		},
		outbound: {
			color: "#481899",
			icon: faList,
			textColor: "#FFFFFF"
		}
	},
	TELEPHONY: {
		PHONERO: {
			INCOMING: {
				color: "#3BBC54",
				icon: faPhone,
				textColor: "gray"
			},

			OUTGOING: {
				color: "#3BBC54",
				icon: faPhoneArrowUpRight,
				textColor: "#3BBC54"
			}
		}
	},
	GENERAL: {
		inbound: {
			color: "#481899",
			icon: faHatWizard,
			textColor: "#FFFFFF"
		},
		outbound: {
			color: "#481899",
			icon: faHatWizard,
			textColor: "#FFFFFF"
		}
	}
};

const ActivityIcon = ({ item, type = null}) => {
	// console.log("!!!!!   item    !!!!!", item, type);
	// is item typeof string, then return a default icon
	if (typeof item === "string" && item === "TASK") {
		return <FontAwesomeIcon icon={faTasks} size={"lg"}/>;
	}
	const {domain, provider, direction, style} = item || {};
	if (type) {
		return <FontAwesomeIcon icon={typeColor[domain]?.[provider]?.[type]?.icon} style={{height: "16px", width: "16px", ...style}}/>;
	}
	else if (typeColor[domain]?.[provider]?.[direction]?.icon) {
		return <FontAwesomeIcon icon={typeColor[domain][provider][direction].icon} style={{height: "16px", width: "16px", ...style}}/>;
	}
	else {
		return <FontAwesomeIcon icon={faEgg} size={"lg"}/>;
	}
};

export default ActivityIcon;
